import { ThreeDots } from 'react-loader-spinner'
import { THEME } from '../../global'

export function FullScreenLoading() {
  return (
    <div className="bg-secondary fixed z-50 top-0 left-0 w-screen h-screen flex items-center justify-center">
      <main className="flex gap-4 items-center justify-center">
        {/* <Logo variant="icon" /> */}

        <ThreeDots
          color={THEME.colors.primary}
          wrapperClass="!w-[3rem] !h-[3rem]"
        />
      </main>
    </div>
  )
}
